import { McIcon } from './icon.js'



export class McIconLetter extends McIcon {
  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" 
  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("mc-icon-letter")) window.customElements.define("mc-icon-letter", McIconLetter)
